// extracted by mini-css-extract-plugin
export default {"list":"i7ZNOl","mobileList":"HmedbB","basketViewDesktop":"Qq58Dd"};